export const engines = {
  ENGINE_TICKET: 4096,
  ENGINE_EXTRA: 4,
  ENGINE_PAYMENT: 64,
  ENGINE_DISCOUNT: 'ENGINE_DISCOUNT',
  ENGINE_ACCOMMODATION: 2,
  ENGINE_TRANSPORT: 1,
  ENGINE_INSURANCE: 256,
  ENGINE_PACKAGE: 16,
  ENGINE_CUSTOMER: 48,
  ENGINE_DELIVERY: 20000,
  ENGINE_SUCCESS: 'ENGINE_SUCCESS',
  ENGINE_ACCOMMODATION_CONFIGURATION: 512,
  ENGINE_BOOKING: 'ENGINE_BOOKING',
  ENGINE_MANDATORY_INFORMATION: 'ENGINE_MANDATORY_INFORMATION',
};
